import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function stripHtml(html: string) {
  const tmp = document.createElement('div');
  tmp.innerHTML = html || '';
  return tmp.textContent || tmp.innerText || '';
}

// locationDisplayName (the raw Google Places autocomplete text) doesn't
// reliably include the country name, and previously masked it whenever it
// was set (which is always, since it's a required field) — so the
// server-geocoded `country` never actually rendered. Append it unless it's
// already present in the display text.
export function formatTeacherLocation(
  locationDisplayName?: string | null,
  city?: string | null,
  state?: string | null,
  country?: string | null,
): string {
  const base = locationDisplayName || [city, state].filter(Boolean).join(", ");
  if (!country || base.toLowerCase().includes(country.toLowerCase())) return base;
  return [base, country].filter(Boolean).join(", ");
}
